import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { Carousel } from '@gem/components';

import { TChatBackground } from 'APP/store/Appearance/Appearance.types';

import { BackgroundItem } from './BackgroundItem/BackgroundItem';
import { useChatBackgroundSelectionPresenter } from './ChatBackgroundSelection.presenter';
import styles from './ChatBackgroundSelection.styles.m.css';
import { UploadBackground } from './UploadBackground/UploadBackground';
import { UploadButton } from './UploadButton/UploadButton';

const ITEMS_GAP = 8;
const ITEMS_SHOW_COUNT = 4.5;

interface TChatBackgroundSelectionProps {
  activeChatBackground: TChatBackground;
  onChatBackgroundChange(chatBackground: TChatBackground): void;
}

export const ChatBackgroundSelection: FC<TChatBackgroundSelectionProps> = observer(
  ({ activeChatBackground, onChatBackgroundChange }) => {
    const presenter = useChatBackgroundSelectionPresenter({
      activeChatBackground,
      onChatBackgroundChange,
    });

    return (
      <div className={styles.container}>
        <Carousel
          className={styles.carousel}
          itemsToShow={ITEMS_SHOW_COUNT}
          gap={ITEMS_GAP}
          withShadow={true}
          activeIndex={presenter.activeIndex ?? undefined}
          isScrollToActiveOnMount={true}
        >
          <UploadButton
            className={classNames(styles.item, styles.upload)}
            key="upload"
            onSelectFile={presenter.onSelectFile}
          />

          {presenter.hasUploadItem && (
            <UploadBackground
              key="upload-bg"
              file={presenter.file!}
              className={classNames(styles.item, styles.upload)}
              onUploadSuccess={presenter.onUploadSuccess}
              onCancelUpload={presenter.onCancelUpload}
            />
          )}

          {presenter.backgrounds.map((background) => (
            <BackgroundItem
              key={background.background}
              background={background}
              onChatBackgroundChange={onChatBackgroundChange}
              onDeleteCustomBackground={presenter.onDeleteCustomBackground}
              className={styles.item}
              isActive={background.background === activeChatBackground.background}
            />
          ))}
        </Carousel>
      </div>
    );
  }
);
